/**
 * @param text - phone/partial number needed to be validated
 * @returns true if valid | false if invalid
 */
export const isValidPartialPhoneNumber = (text: string) =>
    /^[0-9+#*]*$/.test(text);
